<script setup lang="ts">
import { AppFlicker, AppSvgIcon } from '@libs/ui';

import type { PeekPriceMediumBookableTransportCardData } from '../models';

interface PeekPriceMediumBookableTransportCardProps {
  data: PeekPriceMediumBookableTransportCardData;
}

const props = defineProps<PeekPriceMediumBookableTransportCardProps>();
</script>

<template>
  <div class="peek-price-medium-bookable-transport-card">
    <div class="first-row">
      <div class="bookable-transport-date">
        <template v-if="props.data.date">{{ props.data.date }}</template>
        <AppFlicker v-else height="100%" width="spacing-48" />
      </div>
      <div class="bookable-transport-direction">{{ props.data.direction }}</div>
      <div class="bookable-transport-stops">
        <div v-if="props.data.stops">
          {{ props.data.stops }}
        </div>
        <AppFlicker v-else height="100%" width="spacing-48" />
      </div>
    </div>
    <div class="second-row">
      <img
        v-if="props.data.carrierLogoUrl"
        :src="props.data.carrierLogoUrl"
        :alt="props.data.carrierLogoAltText"
        class="bookable-transport-carrier-logo"
      />
      <AppSvgIcon v-else :name="props.data.altLogoIcon" size="24" />
      <div class="bookable-transport-details">
        <div class="bookable-transport-time">
          <template v-if="props.data.time">{{ props.data.time }}</template>
          <div v-else class="transport-time-flicker">
            <AppFlicker height="100%" width="spacing-48" />
          </div>
        </div>
        <div class="bookable-transport-ports">
          <template v-if="props.data.ports">{{ props.data.ports }}</template>
          <div v-else class="transport-ports-flicker">
            <AppFlicker height="100%" width="spacing-48" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.peek-price-medium-bookable-transport-card {
  .first-row {
    display: flex;
    margin-bottom: var(--spacing-8);

    .bookable-transport-date,
    .bookable-transport-direction {
      @include font-label-s-light;
      color: var(--color-neutral-70);
      padding-right: var(--spacing-12);
      margin-right: var(--spacing-12);
      border-right: 1px solid var(--color-neutral-20);
    }

    .bookable-transport-stops {
      @include font-label-s-light;
      color: var(--color-neutral-70);
    }
  }

  .second-row {
    display: flex;
    gap: var(--spacing-12);

    .bookable-transport-carrier-logo {
      --carrier-logo-size: 36px;
      width: var(--carrier-logo-size);
      height: var(--carrier-logo-size);
      object-fit: contain;
    }

    .bookable-transport-details {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-4);

      .bookable-transport-time {
        @include font-label-s-bold;
        color: var(--color-neutral-70);

        .transport-time-flicker {
          height: 15px;
        }
      }

      .bookable-transport-ports {
        @include font-label-s-light;
        color: var(--color-neutral-70);

        .transport-ports-flicker {
          height: 15px;
        }
      }
    }
  }
}
</style>
